import { ContractAddress } from '@/shared/models/Profile'
import { Transfer } from '@/shared/models/Transfer'
import { AssetMetadata } from '@/shared/models/AssetMetadata'

export enum TokenIdType {
  unknown = 0,
  address = 1,
  uint256 = 2,
  bytes32 = 3,
}

export type NftTransfer = Transfer & {
  tokenId: string
  decodedId?: string
}

export type NftCollection = AssetMetadata & {
  contractAddress: ContractAddress
  tokenIdType: TokenIdType
}
